import ChatBulkAuditErrorPicker from 'react-scale/components/audits/ChatBulkAudit/ChatBulkAuditErrorPicker';
import { ChatBulkAuditResultToggle } from 'react-scale/components/audits/ChatBulkAudit/ChatBulkAuditResultToggle';
import { Icon } from '@scale/scaleui';
import { TextInput } from 'design-system';
import { twMerge } from 'tailwind-merge';
import { PerTurnAuditGrade, AuditResultV2 } from '@scale/shared/defaults';

type TurnFeedbackProps = {
  turnIndex: number;
  updateTurnFeedbackField: (fieldValue: any, fieldName: string, index: number) => void;
  projectId: string;
  disableFeedback: boolean;
  classes: any;
  turnFeedback: PerTurnAuditGrade;
};

export const TurnFeedback = ({
  turnIndex,
  turnFeedback,
  projectId,
  disableFeedback,
  updateTurnFeedbackField,
  classes,
}: TurnFeedbackProps) => {
  return (
    <div className={twMerge(classes.containerSection, 'w-full')}>
      <div className="w-full flex flex-col gap-2">
        <div className={'flex flex-row items-center gap-2'}>
          <p className={classes.label}>Turn Rating</p>
          <ChatBulkAuditResultToggle
            value={turnFeedback?.result ?? null}
            onChange={(value: AuditResultV2 | null) => {
              updateTurnFeedbackField(value, 'result', turnIndex);
            }}
            disabled={disableFeedback}
          />
        </div>
        <p className={classes.label}>Turn Error Categories</p>
        <ChatBulkAuditErrorPicker
          enableCreateNewError={false}
          selectedErrorCategories={turnFeedback?.errorCategories ?? []}
          projectId={projectId}
          toggleChoose={(value: string[]) => {
            updateTurnFeedbackField(value, 'errorCategories', turnIndex);
          }}
          isDisabled={disableFeedback}
        />

        <div className={twMerge('flex flex-row gap-2')}>
          <p className={classes.label}>Turn Feedback for CB</p>
          <Icon
            icon="info-circle"
            size="sm"
            tooltip="Persisted in attemptaudit.resultV2.perTurns[i].feedback"
          />
        </div>
        <TextInput
          placeholder="Add descriptive feedback about this specific turn"
          multiline
          disabled={disableFeedback}
          value={turnFeedback?.feedback ?? ''}
          style={{ width: '100%' }}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            updateTurnFeedbackField(
              (event.target as HTMLInputElement).value,
              'feedback',
              turnIndex,
            );
          }}
        />
      </div>
    </div>
  );
};
